/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Reward pool for the coin
 * @export
 * @interface RewardPool
 */
export interface RewardPool {
    /**
     * Reward pool contract address
     * @type {string}
     * @memberof RewardPool
     */
    address?: string;
    /**
     * Reward pool balance
     * @type {number}
     * @memberof RewardPool
     */
    balance?: number;
}

/**
 * Check if a given object implements the RewardPool interface.
 */
export function instanceOfRewardPool(value: object): value is RewardPool {
    let isInstance = true;

    return isInstance;
}

export function RewardPoolFromJSON(json: any): RewardPool {
    return RewardPoolFromJSONTyped(json, false);
}

export function RewardPoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardPool {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'balance': !exists(json, 'balance') ? undefined : json['balance'],
    };
}

export function RewardPoolToJSON(value?: RewardPool | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'balance': value.balance,
    };
}

